import { BottomSheetType } from 'src/types/SchoolType';
import { getDateDifference } from 'src/utils/DateUtils';
import { styled, Typography } from '@mui/material';

import e2 from "src/assets/images/marker_Element_2.svg"
import e4 from "src/assets/images/marker_Element_4.svg"
import normal from "src/assets/images/marker_Element_normal.svg"
import specialize from "src/assets/images/marker_Element_specialize.svg"
import purpose from "src/assets/images/marker_Element_purpose.svg"
import self from "src/assets/images/marker_Element_self.svg"
import Etc from "src/assets/images/marker_Element_Etc.svg"

interface BadgeIconProps{
    color: string;
}

const BadgeIcon = styled('div')<BadgeIconProps>(({ color }) => ({
    borderRadius: '100%',
    backgroundColor: color,
    minWidth: '30px',
    minHeight: '30px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    marginBottom:'auto'
  }));

// 학교 항목 스타일링
const SchoolItemWrapper = styled('div')({ 
    display: 'flex', 
    alignItems: 'center', 
    padding: '16px 20px', 
    backgroundColor:'#fff;',
    width:'100%',
    position:'relative'
});

const TitleWrapper = styled('div')({
  display:'flex',
  justifyContent:'flex-start',
  alignItems:'center',
  gap:'9px'
})

const SchoolItemContiner = styled('div')({
  display:'flex',
  flexDirection:'column',
  gap:'10px'
})

const BoxContainer = styled('div')({
    display:'flex',
    flexDirection:'column',
})

const Divider = styled('div')({
  position:'absolute', 
  width:'calc(100% - 40px)', 
  borderBottom:'1px solid #d3d3d3',
  bottom:0
})

interface Props {
    school: BottomSheetType
}

const TapSearchSchoolName_SchoolList = ({school}:Props) => {
    let color = "#F57749"
    if (school.visited_at){
        const datediff = getDateDifference(school.visited_at)
        if (datediff <= 180) { color = "#57C0AA";} 
        else if (datediff <= 365) { color = "#5CA8E4";} 
        else if (datediff <= 730) { color = "#F5BE49";}
        else if (datediff >= 730) { color = "#F57749";}
    }
    else{
        color = "#F57749"
    }
    let iconic = '';
    // 대학/전문대학 조건
    if (school.school_type === '전문대학') {
      iconic = e2;
    } else if (school.school_type.includes('대학')) {
      iconic = e4;
    } else if (school.school_type === '훈련소' || school.school_type === null){
        iconic = Etc
    }
    // 고등학교 타입 조건
    if (school.school_type === '일반고등학교') {
      iconic = normal;
    } else if (school.school_type === '특성화고등학교') {
      iconic = specialize;
    } else if (school.school_type === '특수목적고등학교') {
      iconic = purpose;
    } else if (school.school_type === '자율고등학교') {
      iconic = self;
    }

    let parseType = ''
      if (school.school_type === '특성화고등학교') {
        parseType = '특성화고'
      } else if (school.school_type === '특수목적고등학교') {
        parseType = '특목고'
      } else if (school.school_type === '자율고등학교') {
        parseType = '자율고'
      }

  return (
    <div>
        <SchoolItemWrapper>
          <SchoolItemContiner>
            <TitleWrapper>
              <BadgeIcon color={color}>
                  <img src={iconic} alt="학교 아이콘" style={{width:'15px',height:'15px'}}/>
              </BadgeIcon>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize:'16px'}}>
                {school.school_name}
              </Typography>
              {parseType &&
                <Typography variant="body2" sx={{color: '#1E9468', padding: '3px 7px', border: '1px solid #1E9468', borderRadius: '3px', fontSize: '12px', height:'20px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                {parseType}
                </Typography>
              }
            </TitleWrapper>
            <BoxContainer style={{width:'100%', paddingLeft:'39px'}}>
                <Typography variant="body2" display="flex" alignItems="center" sx={{opacity:0.5}}>
                  {school.address}
                </Typography>
            </BoxContainer>
          </SchoolItemContiner>
            <Divider/>
        </SchoolItemWrapper>
    </div>
  )
}

export default TapSearchSchoolName_SchoolList